/**
 * Minimal turn shape `referencesTurn` reads. Wider LocalTurn objects satisfy this.
 */
export interface ReferencesTurnCandidate {
  role: 'user' | 'assistant'
  streaming?: boolean
  stopped?: boolean
  refused?: boolean
  citations?: Array<unknown>
}

/**
 * Sources for the references column: the newest grounded assistant answer.
 *
 * A follow-up that is still streaming keeps the previous sources until the
 * new citations arrive. A completed answer with no citations does not clear
 * the rail — scan continues for the previous cited assistant turn. Only the
 * newest assistant turn's stopped or refused state clears the rail; older
 * stopped or refused turns mid-scan are skipped.
 */
export function referencesTurn<T extends ReferencesTurnCandidate>(
  turns: Array<T>,
): T | null {
  let hasSeenAssistant = false

  for (let i = turns.length - 1; i >= 0; i -= 1) {
    const turn = turns[i]
    if (turn.role !== 'assistant') {
      continue
    }

    const isNewestAssistant = !hasSeenAssistant
    hasSeenAssistant = true

    if (turn.streaming && !(turn.citations?.length)) {
      continue
    }
    if (turn.stopped || turn.refused) {
      if (isNewestAssistant) {
        return null
      }
      continue
    }
    if ((turn.citations?.length ?? 0) > 0) {
      return turn
    }
  }

  return null
}
